import React from 'react'
import { IconHandbagSimple, Text, csx } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'

import { DetailsBlockTemplate } from './DetailsBlockTemplate'

export const TakeAwayDetailsBlock = () => {
  const { formatMessage } = useIntl()

  return (
    <DetailsBlockTemplate
      icon={<IconHandbagSimple />}
      title={formatMessage({
        id: 'checkout.shipping.select-shipping-method.to-takeaway',
      })}
      details={
        <Text
          variant="detail"
          tone="secondary"
          className={csx({ display: 'block' })}
        >
          <FormattedMessage id="checkout.shipping-method-selection.pkg-take-away-block-title" />
          <Text variant="detail" tone="positive">
            {' - '}
            <FormattedMessage id="checkout.shipping.select-shipping-method.free-shipping" />
          </Text>
        </Text>
      }
    />
  )
}
